<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{ 'Portfolio List ' }}</strong>
        </div>
        <div class="col-md-1">
          <!-- <download :tableId="'users'" :fileName="'users-list'"></download> -->
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body" v-if="fillableData.basic_information">
      <div class="row mb5">
        <div class="col-md-3">
          <span v-if="fillableData">
            <strong>Purchased Value</strong>
            : {{ getFixed(fillableData.totals.purchase_value) }}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Sold Value</strong>
            : {{ getFixed(fillableData.totals.sell_value) }}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Total Main Categories</strong>
            : {{ (fillableData.basic_information.number_of_main_categorywise) }}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Total Categories</strong>
            : {{ (fillableData.basic_information.number_of_categories) }}
          </span>
        </div>
        <div class="col-md-3">
          <!-- <span v-if="fillableData">
            <strong>Avg holding period</strong>
            : {{getFixed(fillableData.basic_information.avg_holding_period_in_years)}}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Avg sell period</strong>
            : {{getFixed(fillableData.basic_information.avg_sell_period)}}
          </span> 
          <br />-->
          <span v-if="fillableData">
            <strong>Total Returns</strong>
            : {{ getFixed(fillableData.basic_information.total_returns_till_date) }}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Total Portfolio Value</strong>
            : {{ getFixed(fillableData.basic_information.total_portfolio_value) }}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Total Schemes</strong>
            : {{ (fillableData.basic_information.number_of_schemes) }}
          </span>
        </div>
        <div class="col-md-6">
          <span v-if="fillableData">
            <strong>Sum of Latest Value/All values of Schemes.</strong>
            : {{ (fillableData.totals.latest_value_by_total_value).toFixed(2) }}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Sum of Latest Value</strong>
            : {{ getFixed(fillableData.totals.latest_value) }}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Total Profit & Loss</strong>
            : {{ getFixed(fillableData.totals.profit_or_loss) }}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Latest Date</strong>
            : {{ getDateNew(fixDate(fillableData.totals.mutual_funds_run_date)) }}
          </span>
          <br />
          <!-- <span
            v-if="fillableData.all_latest_value_per_all_values_of_company_less_than_point_zero_one"
          >
            <strong>All latest values/All values of comp.(&lt; .01)</strong>
            : {{getFixed(fillableData.basic_information.all_latest_value_per_all_values_of_company_less_than_point_zero_one)}}
          </span> -->
        </div>
      </div>
      <div class="clear-fix"></div>
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-10">
              <h4>Category Portfolios</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'categorywiseportfolios'" :fileName="'categorywise-portfolios'"></download>
            </div>
          </div>
          <div class="table-responsive mb15 app" v-dragscroll="true" v-if="fillableData.categorywise">
            <table id="categorywiseportfolios" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <!-- <th>Sector</th> -->
                  <th v-for="(sect, ind) in categoryFields" v-bind:key="'sector-th' + ind">{{ sect.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fillableData.categorywise" v-bind:key="'sector' + index">
                  <!-- <td>{{Object.keys(row)[0]}}</td> -->
                  <td v-for="(sect, ind) in categoryFields" v-bind:key="'sector-td' + ind">
                    <span v-if="sect.title !== 'total_returns' && sect.title !== 'total_returns_per_total_purchase'">{{
                      (sect.isNumeric) ?
                        getFixed(row[sect.title]) : row[sect.title] }}</span>
                    <span v-else-if="sect.title === 'total_returns'">{{ getFixed(row[sect.title]) }}</span>
                    <span v-else-if="sect.title === 'total_returns_per_total_purchase'">{{ getFixed(row[sect.title])
                      }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-10">
              <h4>Top Scheme</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'topstock'" :fileName="'topscheme'"></download>
            </div>
          </div>
          <div class="table-responsive app">
            <table id="topstock" class="table table-sm first-td-padding table-bordered app-inner">
              <tr v-for="(ts, ind) in topBottomFields" v-bind:key="'stock-top' + ind">
                <td class="text-bold">{{ ts.name }}</td>
                <td>{{ (ts.isNumeric) ? getFixed(fillableData.top_holdings.Scheme[0][ts.title]) :
                  fillableData.top_holdings.Scheme[0][ts.title] }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-10">
              <h4>Main Category wise Portfolios</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'maincategorywise'" :fileName="'maincategorywise'"></download>
            </div>
          </div>
          <div class="table-responsive mb15 app" v-dragscroll v-if="fillableData.maincategorywise">
            <table id="maincategorywise" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <!-- <th>Sector</th> -->
                  <th v-for="(sect, ind) in maincategoryFields" v-bind:key="'mainsector-th' + ind">{{ sect.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fillableData.maincategorywise" v-bind:key="'mainsector' + index">
                  <!-- <td>{{Object.keys(row)[0]}}</td> -->
                  <td v-for="(sect, ind) in maincategoryFields" v-bind:key="'mainsector-td' + ind">
                    <span v-if="sect.title !== 'total_returns' && sect.title !== 'total_returns_per_total_purchase'">{{
                      (sect.isNumeric) ?
                        getFixed(row[sect.title]) : row[sect.title] }}</span>
                    <span v-else-if="sect.title === 'total_returns'">{{ getFixed(row[sect.title]) }}</span>
                    <span v-else-if="sect.title === 'total_returns_per_total_purchase'">{{ getFixed(row[sect.title])
                      }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-10">
              <h4>Equity Category wise Portfolios</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'equitycategorywise'" :fileName="'equitycategorywise'"></download>
            </div>
          </div>
          <div class="table-responsive mb15 app" v-dragscroll v-if="fillableData.equity_category_wise">
            <table id="equitycategorywise" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <!-- <th>Sector</th> -->
                  <th v-for="(sect, ind) in equitycategoryFields" v-bind:key="'equitysector-th' + ind">{{ sect.name }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fillableData.equity_category_wise" v-bind:key="'equitysector' + index">
                  <!-- <td>{{Object.keys(row)[0]}}</td> -->
                  <td v-for="(sect, ind) in equitycategoryFields" v-bind:key="'equitysector-td' + ind">
                    <span
                      v-if="sect.title !== 'total_returns' && sect.title !== 'total_returns_by_sum_of_total_returns'">{{
                        (sect.isNumeric) ?
                          getFixed(row[sect.title]) : row[sect.title] }}</span>
                    <span v-else-if="sect.title === 'total_returns'">{{ getFixed(row[sect.title]) }}</span>
                    <span v-else-if="sect.title === 'total_returns_by_sum_of_total_returns'">{{
                      getFixed(row[sect.title]) }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-10">
              <h4>Top 3 Latest value per all values of company</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'toplvpertv'" :fileName="'top3lvpertv'"></download>
            </div>
          </div>
          <div class="table-responsive mb15 app" v-if="fillableData.top_3_schemes_by_lv_by_tv">
            <table id="toplvpertv" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th :key="'top' + index" v-for="(top, index) in topBottomFields">{{ top.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fillableData.top_3_schemes_by_lv_by_tv" v-bind:key="'top-row' + index">
                  <td :key="'top-td' + index" v-for="(top, index) in topBottomFields">{{ (top.isNumeric) ?
                    getFixed(row[top.title]) : row[top.title] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-10">
              <h4>Bottom 3 Latest value per all values of Schemes</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'btmlvpertv'" :fileName="'bottom3lvpertv'"></download>
            </div>
          </div>
          <div class="table-responsive mb15 app" v-if="fillableData.bottom_3_schemes_by_lv_by_tv">
            <table id="btmlvpertv" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th :key="'bot' + index" v-for="(bot, index) in topBottomFields">{{ bot.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fillableData.bottom_3_schemes_by_lv_by_tv" v-bind:key="'bot-row' + index">
                  <td :key="'bot-td' + index" v-for="(bot, index) in topBottomFields">{{ (bot.isNumeric) ?
                    getFixed(row[bot.title]) : row[bot.title] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-10">
              <h4>Latest value per all values of company (&lt; .01)</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'lvpertv'" :fileName="'lvpertvltpoint01'"></download>
            </div>
          </div>
          <div class="table-responsive mb15 app" v-if="fillableData.latest_value_by_total_value_less_than_point_one">
            <table id="lvpertv" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th :key="'less' + index" v-for="(less, index) in topBottomFields">{{ less.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fillableData.latest_value_by_total_value_less_than_point_one"
                  v-bind:key="'less-row' + index">
                  <td :key="'less-td' + index" v-for="(less, index) in topBottomFields">{{ (less.isNumeric) ?
                    getFixed(row[less.title]) : row[less.title] }}</td>
                </tr>
              </tbody>
              <tfoot v-if="fillableData.latest_value_by_total_value_less_than_point_one.length === 0">
                <tr>
                  <td colspan="3">No data found</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-9">
              <h4>Cummulative Total Returns</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'cummulative-returns'" :fileName="'cummulative-returns'"></download>
            </div>
          </div>
          <div class="table-responsive mb15 app" v-if="fillableData.cummulative_total_returns">
            <table id="cummulative-returns" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th :key="'less' + index" v-for="(less, index) in cummulativeFields">{{ less.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in fillableData.cummulative_total_returns" v-bind:key="'less-row' + index">
                  <td :key="'less-td' + index" v-for="(less, index) in cummulativeFields">{{ (less.isNumeric) ?
                    getFixed(row[less.title]) : row[less.title] }}</td>
                </tr>
              </tbody>
              <tfoot v-if="fillableData.cummulative_total_returns.length === 0">
                <tr>
                  <td colspan="3">No data found</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <!----- CREDITRATING WISE DATA  ----->
      <div class="row">
        <div class="col-md-12"
          v-if="fillableData && fillableData.consolidated_portfolio && fillableData.consolidated_portfolio.credit_ratings_wise">
          <div class="row">
            <div class="col-md-9">
              <h3>Credit Ratings</h3>
            </div>
            <div class="col-md-3">
              <download :tableId="'credit-ratingwise-data'" :fileName="'credit-ratingwise-data'"></download>
            </div>
          </div>
          <table class="table table-bordered font11" :id="'credit-ratingwise-data'">
            <thead>
              <tr>
                <th v-for="(cr, ind) in creditRatingsKeys" v-bind:key="'crth' + ind">{{ cr.name }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(crData, ind) in fillableData.consolidated_portfolio.credit_ratings_wise"
                v-bind:key="'crtr' + ind">
                <td v-for="(cr, ind) in creditRatingsKeys" v-bind:key="'crtd' + ind">
                  <span v-if="cr.datatype == 'numeric'">{{ (crData[cr.title]) ? getChecknFixed(crData[cr.title]) :
                    '' }}</span>
                  <span v-else>{{ crData[cr.title] }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-------- OVERALL RATING -------->
      <div class="row" v-if="fillableData.consolidated_portfolio.overall_ratings">
        <div class="col-md-6"
          v-if="fillableData && fillableData.consolidated_portfolio && fillableData.consolidated_portfolio.overall_ratings.raw && fillableData.consolidated_portfolio.overall_ratings.number">
          <div class="row">
            <div class="col-md-9">
              <h3>Overall Ratings</h3>
            </div>
            <div class="col-md-3">
              <download :tableId="'overallrating'" :fileName="'overallrating'"></download>
            </div>
          </div>
          <table class="table table-bordered font11" :id="'overallrating'">
            <thead>
              <tr>
                <th></th>
                <th>Rating</th>
                <th>Star</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(overallRate, orInd) in overallRatingKeys" :key="orInd + 'overall'">
                <td>{{ overallRate.name }}</td>
                <td>{{ (fillableData.consolidated_portfolio.overall_ratings.raw[overallRate.title]) ?
                  getFixed(fillableData.consolidated_portfolio.overall_ratings.raw[overallRate.title]) : '' }}</td>
                <td>
                  <span>
                    <star-rating v-bind:increment="0.5"
                      v-bind:max-rating="(overallRate.title == 'overall_business_rating' || overallRate.title == 'overall_debt_others_rating' || overallRate.title == 'overall_equity_rating') ? 7 : 5"
                      :rating="parseInt(fillableData.consolidated_portfolio.overall_ratings.number[overallRate.title])"
                      :read-only="true" :show-rating="false" inactive-color="#868e96" active-color="#ffbf00"
                      v-bind:star-size="20"></star-rating>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row" v-if="fillableData && fillableData.dividends">
        <div class="col-md-12">
          <!--  Dividends Table -->
          <div class="table-responsive scrollbar app mb5" v-dragscroll="true">
            <div class="row my-2">
              <div class="col-md-6">
                <h4 class="">Dividend Earned </h4>
              </div>
              <div class="col-md-6">
                <div class="text-right">
                  <download :tableId="'dividends'" :fileName="'Dividends'"></download>
                </div>
              </div>
            </div>
            <table :id="'dividends'" class="table table-bordered fonts11 app-inner">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th v-for="(cl, ind) in dividendKeys" v-bind:key="'trBoddiv' + '-' + ind">{{ cl.name }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(rData, ind) in fillableData.dividends" v-bind:key="'trBod' + '-' + ind">
                  <td>{{ ind + 1 }}</td>
                  <td v-for="(cl, ind1) in dividendKeys" v-bind:key="'tdBoddiv' + '-' + ind1">
                    <span v-if="cl.datatype == 'date'">{{ (rData[cl.title]).split('T')[0] }}</span>
                    <span v-else>{{ rData[cl.title] }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-------EQUITY FUND WISE ------>
      <div class="row">
        <div class="col-md-3">
          <h4>Equity Fundwise Data</h4>
        </div>
        <div class="col-md-1">
          <download :tableId="'usersp1'" :fileName="'user-portfolio'"></download>
        </div>
      </div>

      <div class="table-responsive mt15 app" v-dragscroll="true">
        <table id="usersp1" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="(field, fInd)  in equityTableFields" v-bind:key="fInd + '_field' + field.title">{{ field.title
                }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in fillableData.equity_funds" v-bind:key="'row' + index">
              <td>{{ index + 1 }}</td>
              <td v-for="(field, fInd) in equityTableFields" v-bind:key="field.name + index + 'equity' + fInd">
                <span v-if="field.name === 'name'">{{ row['first_name'] + ' ' + row['last_name'] }}</span>
                <span v-else-if="field.name === 'status'">{{ (row['status'] === false) ? 'Inactive' : 'Active' }}</span>
                <span v-else-if="field.name === 'less_liquid_stock'">{{ (row['less_liquid_stock'] === 0) ?
                  'No' : 'Yes' }}</span>
                <span v-else>
                  <span v-if="field.isNumeric">{{ getChecknFixed(row[field.name]) }}</span>
                  <span v-else-if="field.name === 'date_of_sale'"> {{ (row[field.name] !== curDate) ? row[field.name] :
                    '-' }}</span>
                  <span v-else-if="field.name === 'date_of_purchase'"> {{ (row[field.name] !== curDate) ?
                    row[field.name] :
                    '-' }}</span>
                  <span v-else-if="field.name === 'industry_type'">{{ getCustomLabel(row[field.name]) }}</span>
                  <span v-else>{{ row[field.name] }}</span>
                </span>
              </td>
            </tr>
            <tr>
              <td>{{ 'Total' }}</td>
              <td v-for="(field, fInd)  in equityTableFields" v-bind:key="fInd + '_total_' + field.name">
                <span v-if="field.isNumeric">{{ (fillableData.totals['' + field.name]) ?
                  getChecknFixed(fillableData.totals['' + field.name]) : (fillableData.totals['' + field.name]) ?
                    getChecknFixed(fillableData.totals['' + field.name]) : (fillableData.totals['' + field.name]) ?
                      getChecknFixed(fillableData.totals['' + field.name]) : (fillableData.totals['' + field.name]) ?
                        getChecknFixed(fillableData.totals['' + field.name]) : '-' }}</span>
                <span v-else>{{ (fillableData.totals['' + field.name]) ? fillableData.totals['' + field.name] :
                  (fillableData.totals['' + field.name]) ? fillableData.totals['' + field.name] : '-' }}</span>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length == 0">
            <tr>
              <td :colspan="(equityTableFields.length + 1 + actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <!------- SCHEME WISE ----->
      <div class="row">
        <div class="col-md-3">
          <h4>Schemewise Data</h4>
        </div>
        <div class="col-md-1">
          <download :tableId="'usersp1'" :fileName="'user-portfolio'"></download>
        </div>
      </div>
      <div class="table-responsive mt15 app" v-dragscroll="true">
        <table id="usersp1" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="(field, fInd) in tableFields" v-bind:key="fInd + '-field' + field.title">{{ field.title }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in fillableData.fundwise" v-bind:key="'row' + index">
              <td>{{ index + 1 }}</td>
              <td v-for="(field, fInd) in tableFields" v-bind:key="field.name + index + 'scheme-' + fInd">
                <span v-if="field.name === 'name'">{{ row['first_name'] + ' ' + row['last_name'] }}</span>
                <span v-else-if="field.name === 'status'">{{ (row['status'] === false) ? 'Inactive' : 'Active' }}</span>
                <span v-else-if="field.name === 'less_liquid_stock'">{{ (row['less_liquid_stock'] === 0) ?
                  'No' : 'Yes' }}</span>
                <span v-else>
                  <span v-if="field.isNumeric">{{ getChecknFixed(row[field.name]) }}</span>
                  <span v-else-if="field.name === 'date_of_sale'"> {{ (row[field.name] !== curDate) ? row[field.name] :
                    '-' }}</span>
                  <span v-else-if="field.name === 'date_of_purchase'"> {{ (row[field.name] !== curDate) ?
                    row[field.name] :
                    '-' }}</span>
                  <span v-else-if="field.name === 'industry_type'">{{ getCustomLabel(row[field.name]) }}</span>
                  <span v-else>{{ row[field.name] }}</span>
                </span>
              </td>
            </tr>
            <tr>
              <td>{{ 'Total' }}</td>
              <td v-for="(field, fInd) in tableFields" v-bind:key="fInd + '_total_scheme' + field.name">
                <span v-if="field.isNumeric">{{ (fillableData.totals['' + field.name]) ?
                  getChecknFixed(fillableData.totals['' + field.name]) : (fillableData.totals['' + field.name]) ?
                    getChecknFixed(fillableData.totals['' + field.name]) : (fillableData.totals['' + field.name]) ?
                      getChecknFixed(fillableData.totals['' + field.name]) : (fillableData.totals['' + field.name]) ?
                        getChecknFixed(fillableData.totals['' + field.name]) : '-' }}</span>
                <span v-else>{{ (fillableData.totals['' + field.name]) ? fillableData.totals['' + field.name] :
                  (fillableData.totals['' + field.name]) ? fillableData.totals['' + field.name] : '-' }}</span>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length == 0">
            <tr>
              <td :colspan="(tableFields.length + 1 + actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="pull-right" v-if="totalPages > 1">
          <ul v-if="this.totalPages != 1" class="pagination">
            <li :class="{ disabled: prevDisabled }" class="page-item">
              <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
            </li>
            <li :class="{ disabled: prevDisabled }" class="page-item">
              <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
            </li>
            <li v-for="page in pages" v-bind:key="page" class="page-item"
              :class="(current_page == page) ? 'active' : ''">
              <a class="page-link" @click.prevent="goToPage(page)" href="#">{{ page }}</a>
            </li>
            <li :class="{ disabled: nextDisabled }" class="page-item">
              <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
            </li>
            <li :class="{ disabled: nextDisabled }" class="page-item">
              <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row mt15">
        <div class="col-md-3">
          <h4>Cummulative Data</h4>
        </div>
        <div class="col-md-1">
          <download :tableId="'usersp'" :fileName="'user-portfolio-cummulative'"></download>
        </div>
      </div>
      <div class="table-responsive mt15 app" v-dragscroll="true">
        <table id="usersp" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="(field, fInd) in cummTableFields" v-bind:key="fInd + 'field' + field.title">{{ field.title }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in fillableData.cumulative_data" v-bind:key="'row' + index">
              <td>{{ index + 1 }}</td>
              <td v-for="(field, fInd)  in cummTableFields" v-bind:key="field.name + index + 'category_' + fInd">
                <span v-if="field.name === 'name'">{{ row['first_name'] + ' ' + row['last_name'] }}</span>
                <span v-else-if="field.name === 'status'">{{ (row['status'] === false) ? 'Inactive' : 'Active' }}</span>
                <span v-else-if="field.name === 'stockwise_total_return_percent'">{{
                  getChecknFixed(fillableData.stockwise_total_return_percent[row['co_code']]) }}</span>
                <span v-else-if="field.name === 'less_liquid_stock'">{{ (row['less_liquid_stock'] === 0) ?
                  'No' : 'Yes' }}</span>
                <span v-else>
                  <span v-if="field.isNumeric">{{ getChecknFixed(row[field.name]) }}</span>
                  <span v-else-if="field.name === 'industry_type'">{{ getCustomLabel(row[field.name]) }}</span>
                  <span v-else>{{ row[field.name] }}</span>
                </span>
              </td>
            </tr>
            <tr>
              <td>{{ 'Total' }}</td>
              <td v-for="(field, fInd)  in cummTableFields" v-bind:key="fInd + '_total_cummulative' + field.name">
                <span v-if="field.isNumeric">{{ (fillableData.totals['' + field.name]) ?
                  getChecknFixed(fillableData.totals['' + field.name]) : (fillableData.totals['' + field.name]) ?
                    getChecknFixed(fillableData.totals['' + field.name]) : (fillableData.totals['' + field.name]) ?
                      getChecknFixed(fillableData.totals['' + field.name]) : (fillableData.totals['' + field.name]) ?
                        getChecknFixed(fillableData.totals['' + field.name]) : '-' }}</span>
                <span v-else>{{ (fillableData.totals['' + field.name]) ? fillableData.totals['' + field.name] :
                  (fillableData.totals['' + field.name]) ? fillableData.totals['' + field.name] : '-' }}</span>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length == 0">
            <tr>
              <td :colspan="(cummTableFields.length + 1 + actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="row mt15">
        <div class="col-md-3">
          <h4>Portfolio Values</h4>
        </div>
        <div class="col-md-1">
          <download :tableId="'usersportfoliovalues'" :fileName="'user-portfolio-values'"></download>
        </div>
      </div>
      <div class="table-responsive mt15 app" v-dragscroll="true">
        <table id="usersportfoliovalues" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th></th>
              <th v-for="period in cummulativePeriodicValues" v-bind:key="'period' + period.title">{{ period.name }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in fillableData.portfolio_values" v-bind:key="'row' + index">
              <td>{{ index + 1 }}</td>
              <td v-for="(field, fInd) in cummulativePeriodicValues" v-bind:key="fInd + field.title + index">
                <span>
                  <span v-if="field.type === 'numeric'">{{ getChecknFixed(row['' + field.title]) }}</span>
                  <span v-else-if="field.title === 'industry_type'">{{ getCustomLabel(row[field.title]) }}</span>
                  <span v-else>{{ row[field.title] }}</span>
                </span>
              </td>
            </tr>
            <!-- <tr>
              <td>{{'Total'}}</td>
              <td v-for="field in cummulativePeriodicValues" v-bind:key="'total_'+field.name">
                <span
                  v-if="field.type==='numeric'"
                >{{(fillableData.portfolio_values[''+field.title])? getChecknFixed(fillableData.portfolio_values[''+field.title]) : '-'}}</span>
                <span
                  v-else
                >{{(fillableData.portfolio_values[''+field.title])? fillableData.portfolio_values[''+field.title] : '-'}}</span>
              </td>
            </tr> -->
          </tbody>
          <tfoot v-if="fillableData.length == 0">
            <tr>
              <td :colspan="(tableFields.length + 1 + actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="row mt15">
        <div class="col-md-3">
          <h4>Meand &amp; SD </h4>
        </div>
        <div class="col-md-1">
          <download :tableId="'usersportfoliovalues'" :fileName="'user-portfolio-values'"></download>
        </div>
      </div>
      <div class="table-responsive mt15 app" v-dragscroll="true">
        <table id="usersportfoliovalues" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <!-- <th>{{data.schemeName}}</th> -->
              <th style="padding: 10px 80px;">Duration</th>
              <th v-for="(th, ind1) in durations" v-bind:key="'thr' + '-' + ind1" colspan="4">{{ th }}</th>
            </tr>
            <tr>
              <th> Scheme Name</th>
              <template v-for="(th, ind1) in durations">
                <th v-for="(th, ind) in durationMeanSdCols" v-bind:key="'rankTH' + '-' + ind + th + ind1">
                  {{ th.name }}
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in fillableData.rolling_returns_summary.table" v-bind:key="'row' + index">
              <td>{{ row['sch_name'] }}</td>
              <td v-for="(field, fInd) in schemeMeanSDCols" v-bind:key="fInd + field.title + index">
                <span>
                  <span v-if="field.datatype === 'numeric'">{{ getChecknFixed(row['' + field.title]) }}</span>
                  <span v-else>{{ row[field.title] }}</span>
                </span>
              </td>
            </tr>
            <tr>
              <td>{{ 'Portfolio' }}</td>
              <td v-for="(field, find) in schemeMeanSDCols" v-bind:key="find + 'total_' + field.title">
                <span v-if="field.datatype === 'numeric'">{{ (fillableData.rolling_returns_summary.totals['' +
                  field.title]) ?
                  getChecknFixed(fillableData.rolling_returns_summary.totals['' + field.title]) : '-' }}</span>
                <span v-else>{{ (fillableData.rolling_returns_summary.totals['' + field.title]) ?
                  fillableData.rolling_returns_summary.totals['' + field.title] : '-' }}</span>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.rolling_returns_summary.table.length == 0">
            <tr>
              <td :colspan="(tableFields.length + 1 + actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import StarRating from "vue-star-rating";
import { commonMixins } from "../../../assets/mixins/common.js";
export default {
  components: { StarRating },
  mixins: [commonMixins],
  name: "UserPortfolio",
  props: ["user"],
  created() {
    if (!this.$route.params.id) {
      this.$router.push({ name: "mf-users" });
    }
    console.log("Config ", process.env.API_URL);
    this.url = this.apiUrl;
    this.userId = this.$route.params.id;
    console.log(
      this.url.indexOf("user-portfolio"),
      this.$route.params,
      this.$route.query
    );
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = "");
    this.url += this.pageToLoad;
    this.current_page = this.pageToLoad;
    this.fetchData(this.searchParams);
  },
  watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  },
  data() {
    return {
      apiUrl: "mutual-funds/portfolio/user/",
      apiMode: true,
      curDate: ("0" + (new Date().getDate())).slice(-2) + '-' + ("0" + (new Date().getMonth() + 1)).slice(-2) + '-' + new Date().getFullYear(),
      company: {},
      actions: [],
      divEarnedTableFields: [
        {
          title: "year",
          name: "Year",
          isNumeric: true
        },
        {
          title: "no_of_share_held",
          name: "No. of Shares Held",
          isNumeric: true
        },
        {
          title: "dividend_per_share",
          name: "Dividend per share",
          isNumeric: true
        },
        { title: "dividend_earned", name: "Dividend Earned", isNumeric: true }
      ],
      equityTableFields: [
        {
          name: "sch_name",
          title: "Scheme",
          isNumeric: 0
        },
        {
          name: "Category",
          title: "Category",
          isNumeric: 0
        },
        {
          name: "MainCategory",
          title: "Main Category",
          isNumeric: 0
        },
        {
          name: "LatestNAV",
          title: "Latest NAV",
          isNumeric: 1
        },
        {
          name: "no_of_units_purchased",
          title: "No of Units purchased",
          isNumeric: 0
        },
        {
          name: "no_of_units_sold",
          title: "No of units Sold",
          isNumeric: 0
        },
        {
          name: "no_of_units_held",
          title: "No of units Held",
          isNumeric: 0
        },
        {
          name: "SD",
          title: "SD",
          isNumeric: 1
        },
        {
          name: "BETA",
          title: "BETA",
          isNumeric: 1
        },
        {
          name: "SD",
          title: "SD",
          isNumeric: 1
        },
        {
          name: "latest_value",
          title: "Latest Value",
          isNumeric: 0
        },
        {
          name: "overall_business_rating_number",
          title: "Business Rating",
          isNumeric: 0
        },
        {
          name: "overall_business_rating_value",
          title: "Business Rating Value",
          isNumeric: 1
        },
        {
          name: "overall_valuation_rating_number",
          title: "Valuation Rating",
          isNumeric: 0
        },
        {
          name: "overall_valuation_rating_value",
          title: "Valuation Rating Value",
          isNumeric: 1
        },
        {
          name: "overall_quarterly_rating_number",
          title: "Quarterly Rating",
          isNumeric: 0
        },
        {
          name: "overall_quarterly_rating_value",
          title: "Quarterly Rating Value",
          isNumeric: 1
        },
        {
          name: "overall_debt_others_rating_number",
          title: "Debt Others Rating",
          isNumeric: 0
        },
        {
          name: "overall_debt_others_rating_value",
          title: "Debt Others Rating Value",
          isNumeric: 1
        },
        {
          name: "overall_equity_rating_number",
          title: "Equity Rating",
          isNumeric: 0
        },
        {
          name: "overall_equity_rating_value",
          title: "Equity Rating Value",
          isNumeric: 1
        },
        {
          name: "overall_scheme_rating_number",
          title: "Scheme Rating",
          isNumeric: 0
        },
        {
          name: "overall_scheme_rating_value",
          title: "Scheme Rating Value",
          isNumeric: 1
        },
      ],
      tableFields: [
        {
          name: "sch_name",
          title: "Scheme",
          isNumeric: 0
        },
        {
          name: "Category",
          title: "Category",
          isNumeric: 0
        },
        {
          name: "MainCategory",
          title: "Main Category",
          isNumeric: 0
        },
        {
          name: "LatestNAV",
          title: "Latest NAV",
          isNumeric: 1
        },
        {
          name: "no_of_units_purchased",
          title: "No of Units purchased",
          isNumeric: 0
        },
        {
          name: "nav_per_unit_purchased",
          title: "Purchase NAV",
          isNumeric: 0
        },
        {
          name: "no_of_units_sold",
          title: "No of units Sold",
          isNumeric: 0
        },
        {
          name: "nav_per_unit_sold",
          title: "Sell NAV",
          isNumeric: 0
        },
        {
          name: "no_of_units_held",
          title: "No of units Held",
          isNumeric: 0
        },
        {
          name: "day_purchase_value",
          title: "Purchase Value",
          isNumeric: 1
        },
        {
          name: "day_sell_value",
          title: "Sell Value",
          isNumeric: 1
        },
        {
          name: "SD",
          title: "SD",
          isNumeric: 1
        },
        {
          name: "BETA",
          title: "BETA",
          isNumeric: 1
        },
        {
          name: "SD",
          title: "SD",
          isNumeric: 1
        },
        {
          name: "latest_value",
          title: "Latest Value",
          isNumeric: 0
        },
        {
          name: "overall_business_rating_number",
          title: "Business Rating",
          isNumeric: 0
        },
        {
          name: "overall_business_rating_value",
          title: "Business Rating Value",
          isNumeric: 1
        },
        {
          name: "overall_valuation_rating_number",
          title: "Valuation Rating",
          isNumeric: 0
        },
        {
          name: "overall_valuation_rating_value",
          title: "Valuation Rating Value",
          isNumeric: 1
        },
        {
          name: "overall_quarterly_rating_number",
          title: "Quarterly Rating",
          isNumeric: 0
        },
        {
          name: "overall_quarterly_rating_value",
          title: "Quarterly Rating Value",
          isNumeric: 1
        },
        {
          name: "overall_debt_others_rating_number",
          title: "Debt Others Rating",
          isNumeric: 0
        },
        {
          name: "overall_debt_others_rating_value",
          title: "Debt Others Rating Value",
          isNumeric: 1
        },
        {
          name: "overall_equity_rating_number",
          title: "Equity Rating",
          isNumeric: 0
        },
        {
          name: "overall_equity_rating_value",
          title: "Equity Rating Value",
          isNumeric: 1
        },
        {
          name: "overall_scheme_rating_number",
          title: "Scheme Rating",
          isNumeric: 0
        },
        {
          name: "overall_scheme_rating_value",
          title: "Scheme Rating Value",
          isNumeric: 1
        },
      ],
      cummTableFields: [
        {
          name: "sch_name",
          title: "Scheme",
          isNumeric: 0
        },
        {
          name: "Category",
          title: "Category",
          isNumeric: 0
        },
        {
          name: "MainCategory",
          title: "Main Category",
          isNumeric: 0
        },
        {
          name: "LatestNAV",
          title: "Latest NAV",
          isNumeric: 1
        },
        {
          name: "no_of_units_purchased",
          title: "No of Units purchased",
          isNumeric: 0
        },
        {
          name: "avg_purchase_price",
          title: "Avg Price/Share",
          isNumeric: 1
        },
        {
          name: "purchase_value",
          title: "Purchased Value",
          isNumeric: 0
        },
        {
          name: "purchase_cost_of_units_held",
          title: "Purchase cost for units held",
          isNumeric: 1
        },
        {
          name: "no_of_units_sold",
          title: "No of units Sold",
          isNumeric: 0
        },
        {
          name: "sell_value",
          title: "Sell Value",
          isNumeric: 0
        },
        {
          name: "avg_sell_price",
          title: "Avg Sale Price",
          isNumeric: 1
        },
        {
          name: "no_of_units_held",
          title: "No of units Held",
          isNumeric: 0
        },
        {
          name: "profit_or_loss",
          title: "Profit/Loss",
          isNumeric: 1
        },
        {
          name: "unreliazed_profit_or_loss",
          title: "Unrealized Profit/Loss",
          isNumeric: 1
        },
        {
          name: "unreliazed_profit_or_loss_by_purchase_cost_of_units_held",
          title: "Unrealized Profit/Loss / Purchase cost for units held",
          isNumeric: 1
        },
        {
          name: "unreliazed_profit_or_loss_by_total_of_unreliazed_profit_or_loss",
          title: "Unrealized Profit/Loss / Total Unrealized Profit/Loss",
          isNumeric: 1
        },
        {
          name: "SD",
          title: "SD",
          isNumeric: 1
        },
        {
          name: "dividend_earned",
          title: "Dividend Earned",
          isNumeric: 1
        },
        {
          name: "total_returns",
          title: "Total Returns",
          isNumeric: 1
        },
        {
          name: "total_returns_percent",
          title: "Total Returns/Purchase Cost",
          isNumeric: 1
        },
        {
          name: "total_returns_by_purchase_value",
          title: "Total returns by Purchase Value",
          isNumeric: 1
        },
        {
          name: "overall_business_rating_number",
          title: "Business Rating",
          isNumeric: 0
        },
        {
          name: "overall_valuation_rating_number",
          title: "Valuation Rating",
          isNumeric: 0
        },
        {
          name: "overall_quarterly_rating_number",
          title: "Quarterly Rating",
          isNumeric: 0
        },
        {
          name: "overall_debt_others_rating_number",
          title: "Debt Others Rating",
          isNumeric: 0
        },
        {
          name: "overall_scheme_rating_number",
          title: "Scheme Rating",
          isNumeric: 0
        },
        {
          name: "overall_scheme_rating_by_latest_value_by_total_value",
          title: "Scheme Rating/LV/TV",
          isNumeric: 1
        },
        {
          name: "latest_value",
          title: "Latest Value",
          isNumeric: 0
        },
        {
          name: "latest_value_by_total_value",
          title: "Latest value/All Values",
          isNumeric: 1
        }
      ],
      liquidityFields: [
        { title: 'name_of_stock', name: 'Stock', isNumeric: 0, type: 'string', isLink: true, unit: '' },
        { title: 'no_of_share_held', name: 'No. of Shares held', isNumeric: 0, type: 'numeric', isLink: false, unit: '' },
        { title: 'avg_vol', name: 'Avg Volume traded', isNumeric: 1, type: 'numeric', isLink: false, unit: '' },
        { title: 'liquidity', name: 'No. of Shares held/Avg Volume', isNumeric: 1, type: 'numeric', isLink: false, unit: '' },
        { title: 'days_to_sell', name: 'Days to sell', type: 'numeric', isNumeric: 1, isLink: false, unit: '' },
        { title: 'less_liquid_stock', name: 'Less Liquidity', isNumeric: 1, type: 'boolean', isLink: false, unit: '' },
        { title: 'latest_value', name: 'Latest Value', isNumeric: 1, type: 'numeric', isLink: false, unit: '(Rs.)' },
        { title: 'latest_value_by_total_value', name: 'LV/TV', isNumeric: 1, type: 'numeric', isLink: false, unit: '(%)' },
      ],
      topBottomFields: [
        { title: "mf_schcode", name: "Code", isNumeric: false },
        { title: "sch_name", name: "Scheme", isNumeric: false },
        {
          title: "latest_value_by_total_value",
          name: "Latest value/All Values of Schemes",
          isNumeric: true
        }
      ],
      categoryFields: [
        { title: "Category", name: "Category", isNumeric: false },
        { title: "total_returns", name: "Total Returns", isNumeric: true },
        {
          title: "total_returns_by_purchase_value",
          name: "Total Returns/Purchase Cost",
          isNumeric: true
        },
        {
          title: "latest_value_by_total_value",
          name: "Latest value/Total Value",
          isNumeric: true
        }
      ],
      maincategoryFields: [
        { title: "MainCategory", name: "Main Category", isNumeric: false },
        { title: "total_returns", name: "Total Returns", isNumeric: true },
        {
          title: "total_returns_by_purchase_value",
          name: "Total Returns/Purchase Cost",
          isNumeric: true
        },
        {
          title: "latest_value_by_total_value",
          name: "Latest value/Total Value",
          isNumeric: true
        }
      ],
      equitycategoryFields: [
        { title: "MainCategory", name: "Main Category", isNumeric: false },
        { title: "Category", name: "Category", isNumeric: false },
        { title: "total_returns", name: "Total Returns", isNumeric: true },
        {
          title: "total_returns_by_sum_of_total_returns",
          name: "Total Returns/Sum of Total Returns",
          isNumeric: true
        },
      ],
      cummulativeFields: [
        { title: "sch_name", name: "Scheme", isNumeric: false },
        { title: "MainCategory", name: "Main Category", isNumeric: false },
        { title: "Category", name: "Category", isNumeric: false },
        { title: "total_returns", name: "Total return", isNumeric: true },
        {
          title: "total_returns_percent",
          name: "Total return %",
          isNumeric: true
        }
      ],
      compIndexFields: [
        { title: "IndexDate", name: "Date", isNumeric: false, type: "date" },
        { title: "IndexName", name: "Name", isNumeric: false, type: "string" },
        { title: "IndexValue", name: "Value", isNumeric: true, type: "number" },
        {
          title: "composite_index_value",
          name: "Composite Index Value",
          isNumeric: true,
          type: "number"
        }
      ],
      cummulativePeriodicValues: [
        { title: "sch_name", name: "Scheme", isNumeric: false },
        { title: "Category", name: "Category", isNumeric: false },
        { title: "MainCategory", name: "Main Category", isNumeric: false },
        { title: "no_of_units_held", name: "No of Units Held", isNumeric: false, type: "" },
        { title: "1day", name: "1 Day", isNumeric: true, type: "numeric" },
        { title: "1week", name: "1 Week", isNumeric: true, type: "numeric" },
        {
          title: "1month",
          name: "1 Month",
          isNumeric: true,
          type: "numeric"
        },
        {
          title: "3month",
          name: "3 Months",
          isNumeric: true,
          type: "numeric"
        },
        {
          title: "6month",
          name: "6 Months",
          isNumeric: true,
          type: "numeric"
        },
        { title: "1year", name: "1 Year", isNumeric: true, type: "numeric" },
        {
          title: "2year",
          name: "2 Years",
          isNumeric: true,
          type: "numeric"
        },
        {
          title: "3year",
          name: "3 Years",
          isNumeric: true,
          type: "numeric"
        },
        {
          title: "5year",
          name: "5 Years",
          isNumeric: true,
          type: "numeric"
        },
        {
          title: "inception_date",
          name: "Since Inception",
          isNumeric: true,
          type: "numeric"
        }
      ],
      creditRatingsKeys: [
        {
          title: 'TYPE',
          name: this.getLabel('name'),
          isLink: 0,
          datatype: 'string',
          sort_order: 2,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'consol_perc_hldg',
          name: this.getLabel('Consolidated % holdg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 12,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'consol_perc_hldg_adj',
          name: this.getLabel('Adj. Consolidated % holdg'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 13,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'business_rating',
          name: this.getLabel('business_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 4,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'business_rating_adj',
          name: this.getLabel('adj_business_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 7,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'valuation_rating',
          name: this.getLabel('valuation_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 5,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'valuation_rating_adj',
          name: this.getLabel('adj_valuation_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 8,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'quarterly_rating',
          name: this.getLabel('quarterly_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 6,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'quarterly_rating_adj',
          name: this.getLabel('adj_quarterly_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 9,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'debt_others_rating',
          name: this.getLabel('Debt_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 6,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'debt_others_rating_adj',
          name: this.getLabel('adj_debt_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 9,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'overall_rating',
          name: this.getLabel('Overall Rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 10,
          sort: 0,
          isSortable: 1
        },
        {
          title: 'overall_rating_adj',
          name: this.getLabel('adj_overall_rating'),
          isLink: 0,
          datatype: 'numeric',
          sort_order: 11,
          sort: 0,
          isSortable: 1
        }
      ],
      overallRatingKeys: [
        {
          title: 'overall_business_rating',
          name: 'Business Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_valuation_rating',
          name: 'Valuation Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_quarterly_rating',
          name: 'Quarterly Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_debt_others_rating',
          name: 'Debt & Others Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_equity_rating',
          name: 'Equity Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_scheme_rating',
          name: 'Scheme Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
        {
          title: 'overall_weighted_scheme_rating',
          name: 'Weighted Scheme Rating',
          isLink: 0,
          datatype: 'numeric',
          sort_order: 1,
          sort: 0,
          isSortable: 0
        },
      ],
      dividendKeys: [
        { title: 'Mf_SchCode', name: 'Mf Code', isLink: 0, datatype: 'string', sort_order: 1, sort: 0, isSortable: 0 },
        { title: 'Sch_Name', name: 'Scheme', isLink: 0, datatype: 'string', sort_order: 1, sort: 0, isSortable: 0 },
        { title: 'DivDate', name: 'Div Date', isLink: 0, datatype: 'date', sort_order: 1, sort: 0, isSortable: 0 },
        { title: 'Divtype', name: 'Div Type', isLink: 0, datatype: 'string', sort_order: 1, sort: 0, isSortable: 0 },
        { title: 'units_held', name: 'Units Held', isLink: 0, datatype: 'string', sort_order: 1, sort: 0, isSortable: 0 },
        { title: 'dividend_earned', name: 'Dividend Earned', isLink: 0, datatype: 'string', sort_order: 1, sort: 0, isSortable: 0 },
        { title: 'DivAmount', name: 'Dividend Amount', isLink: 0, datatype: 'string', sort_order: 1, sort: 0, isSortable: 0 },
      ],
      durations: ['3M', '1Y', '3Y', '5Y'],
      durationMeanSdCols: [
        { title: 'MEAN_NAV_RR', subTitle: '', name: 'Mean', datatype: 'numeric' },
        { title: 'MEAN_NAV_RR', subTitle: '_x_LV_BY_TV', name: 'Mean X LV/TV', datatype: 'numeric' },
        { title: 'SD_NAV_RR', subTitle: '', name: 'SD', datatype: 'numeric' },
        { title: 'SD_NAV_RR', subTitle: '_x_LV_BY_TV', name: 'SD X LV/TV', datatype: 'numeric' },
      ],
      schemeMeanSDCols: [
        // {title: 'sch_name', name: 'Mean', datatype: 'numeric'},
        // {title: 'latest_value_by_total_value', name: 'LV/TV', datatype: 'numeric'},
        { title: 'MEAN_NAV_RR_3M', name: 'Mean', datatype: 'numeric' },
        { title: 'MEAN_NAV_RR_3M_x_LV_BY_TV', name: 'Mean X LV/TV', datatype: 'numeric' },
        { title: 'SD_NAV_RR_3M', name: 'SD', datatype: 'numeric' },
        { title: 'SD_NAV_RR_3M_x_LV_BY_TV', name: 'SD X LV/TV', datatype: 'numeric' },
        { title: 'MEAN_NAV_RR_1Y', name: 'Mean', datatype: 'numeric' },
        { title: 'MEAN_NAV_RR_1Y_x_LV_BY_TV', name: 'Mean X LV/TV', datatype: 'numeric' },
        { title: 'SD_NAV_RR_1Y', name: 'SD', datatype: 'numeric' },
        { title: 'SD_NAV_RR_1Y_x_LV_BY_TV', name: 'SD X LV/TV', datatype: 'numeric' },
        { title: 'MEAN_NAV_RR_3Y', name: 'Mean', datatype: 'numeric' },
        { title: 'MEAN_NAV_RR_3Y_x_LV_BY_TV', name: 'Mean X LV/TV', datatype: 'numeric' },
        { title: 'SD_NAV_RR_3Y', name: 'SD', datatype: 'numeric' },
        { title: 'SD_NAV_RR_3Y_x_LV_BY_TV', name: 'SD X LV/TV', datatype: 'numeric' },
        { title: 'MEAN_NAV_RR_5Y', name: 'Mean', datatype: 'numeric' },
        { title: 'MEAN_NAV_RR_5Y_x_LV_BY_TV', name: 'Mean X LV/TV', datatype: 'numeric' },
        { title: 'SD_NAV_RR_5Y', name: 'SD', datatype: 'numeric' },
        { title: 'SD_NAV_RR_5Y_x_LV_BY_TV', name: 'SD X LV/TV', datatype: 'numeric' },
      ],
      paginationPath: "",
      searchParams: {},
      sectorData: [],
      fillableData: [],
      url: "",
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      userId: 0
    };
  },
  methods: {
    reset() {
      // window.location.reload();
      this.$router.push({ name: "user-listing" });
      this.searchParams = { userid: this.userId };
      this.pageToLoad = 1;
      this.current_page = 1;
      this.url = this.apiUrl + this.pageToLoad;
      this.fetchData(this.searchParams);
    },
    fetchData(data) {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        // let params = data ? { userid: this.userId } : {};
        http.get(this.url + '' + this.userId, {}, function (error, response) {
          console.log("## ", response);
          // if (response.responseType === "success") {
          myself.fillableData = response;

          /* try {
            myself.fillableData.consolidated_portfolio.overall_ratings.raw = {};
          } catch (error) {
            console.log('error', error);
          } */
          /* try {
            if (myself.fillableData.portfolio_values) {
              console.log('==> portfolio_values >>> ', myself.fillableData.portfolio_values);
            }
          } catch (error) {
            console.log('==> portfolio_values >>> error', error);
            myself.fillableData.portfolio_values = [];
          } */
          console.log('myself.fillableData >>>', myself.fillableData);
          //Total of portfolio Values 

          if (myself.fillableData.portfolio_values.length) {
            var lastInd = myself.fillableData.portfolio_values.length;
            var portfolioTotals = { "sch_name": "", "1day": 0, "1week": 0, "1month": 0, "3month": 0, "6month": 0, "1year": 0, "2year": 0, "3year": 0, "5year": 0, "inception_date": 0 };
            myself.fillableData.portfolio_values.forEach((portfolioValue, portfolioKey) => {
              portfolioTotals['sch_name'] = 'Total';
              myself.cummulativePeriodicValues.forEach((periodValue, periodKey) => {
                if (myself.checkNotInArray(['sch_name', 'Category', 'MainCategory', 'mf_schcode', 'no_of_units_held'], periodValue.title)) {
                  console.log('SUM', periodValue.title, portfolioValue[periodValue.title]);
                  if (portfolioValue[periodValue.title]) {
                    console.log(portfolioTotals[periodValue.title]);
                    portfolioTotals[periodValue.title] = portfolioTotals[periodValue.title] + portfolioValue[periodValue.title];
                  }
                  console.log(portfolioTotals[periodValue.title]);
                }
              });
            });
            myself.fillableData.portfolio_values[lastInd] = portfolioTotals;
          }

          console.log(myself.fillableData.portfolio_values);
          // myself.current_page = myself.pageToLoad;
          // myself.totalPages = response.total_pages;
          // myself.prevDisabled = myself.pageToLoad == 1;
          // myself.nextDisabled = myself.current_page == myself.totalPages;
          // myself.isLoading = false;
          // // set 5 pages to show
          // console.log("current", myself.current_page);
          // let i = 5;
          // let page = myself.current_page - 2;
          // if (page <= 0) page = 1;
          // myself.pages = [];
          // while (i) {
          //   myself.pages.push(parseInt(page));
          //   if (myself.totalPages <= page) break;
          //   page++;
          //   i--;
          // }
          // console.log("PAges", myself.pages);
          // } else {
          //   console.log(error);
          // }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      if (this.pageToLoad != this.current_page) url += this.pageToLoad;
      this.url = url;
      this.fetchData(this.searchParams);
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    },
    editUser(row, index, $event) {
      console.log(row, index, $event);
      http.get("user/" + row.id, {}, (error, response) => {
        this.$router.push({
          name: "edit-user",
          params: { user: response, isFromComp: 1 }
          // query: Object.assign({}, this.$route.query, { id: row.co_code })
        });
        //TODO:: add company updates into our array in future
      });
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/mutual-funds/acl/user-portfolios.vue